import { useEmojiStatus } from '../hooks/useEmojiStatus';
import { haptic } from '../utils/haptic';
import { IconSparkles, IconBolt, CloseIcon } from './icons';
import './EmojiStatusOffer.css';

// Replace with the actual custom_emoji_id after creating a sticker pack via BotFather.
// See docs: https://core.telegram.org/bots/api#getcustomemojistickers
const VIBE_CODER_EMOJI_ID = import.meta.env.VITE_VIBE_CODER_EMOJI_ID || '';

interface EmojiStatusOfferProps {
  onDismiss: () => void;
}

export function EmojiStatusOffer({ onDismiss }: EmojiStatusOfferProps) {
  const { isAvailable, status, requestAndSet } = useEmojiStatus();

  if (!isAvailable || !VIBE_CODER_EMOJI_ID) return null;

  if (status === 'granted') {
    return (
      <div className="emoji-offer emoji-offer-success">
        <span className="emoji-offer-icon"><IconSparkles size={22} /></span>
        <div className="emoji-offer-text">
          <div className="emoji-offer-title">Статус установлен!</div>
          <div className="emoji-offer-subtitle">Все контакты видят что ты — Vibe Coder</div>
        </div>
      </div>
    );
  }

  return (
    <div className="emoji-offer">
      <span className="emoji-offer-icon"><IconBolt size={22} /></span>
      <div className="emoji-offer-text">
        <div className="emoji-offer-title">Покажи что ты Vibe Coder</div>
        <div className="emoji-offer-subtitle">
          Установи эмодзи-статус — его увидят все контакты
        </div>
      </div>
      <button
        className="emoji-offer-btn"
        onClick={() => {
          haptic.tap();
          requestAndSet(VIBE_CODER_EMOJI_ID, 3600);
        }}
      >
        Установить
      </button>
      <button
        className="emoji-offer-close"
        onClick={() => {
          haptic.tap();
          onDismiss();
        }}
      >
        <CloseIcon size={14} />
      </button>
    </div>
  );
}
